var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [
              _c(
                "text-header",
                {
                  staticClass: "atmo-hash-jump-point",
                  attrs: { id: "atmo-contract-fulfillment" },
                },
                [_vm._v("Исполнение контракта")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.purchase.is_customer
        ? [
            _c(
              "form-row-single-select",
              {
                attrs: {
                  options: _vm.dictionaries.purchaseStatuses,
                  "label-field": "title",
                  label: "Изменить статус закупки",
                  "content-cols-lg": 8,
                  "content-cols-sm": 9,
                },
                model: {
                  value: _vm.form.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "status", $$v)
                  },
                  expression: "form.status",
                },
              },
              [
                _c(
                  "b-overlay",
                  {
                    staticClass: "d-inline-block",
                    attrs: {
                      show: _vm.isDataSending,
                      opacity: "0.6",
                      rounded: "",
                      "spinner-small": "",
                      "spinner-variant": "primary",
                    },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "text-uppercase ml-3",
                        attrs: {
                          variant: "custom-green",
                          disabled:
                            _vm.form.status === _vm.purchase.status.id ||
                            _vm.$v.form.$invalid,
                        },
                        on: { click: _vm.changeStatus },
                      },
                      [_vm._v(" Изменить статус ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("form-row-upload-multiple-documents", {
              attrs: {
                "is-loading": _vm.isWaiting,
                v: _vm.$v.executionDocuments,
                "header-class": "fs-14 fix-pos",
                title: "Документы об исполнении",
                compact: "",
                "with-number": "",
              },
              on: { add: _vm.onAddFile, remove: _vm.onRemoveFile },
              model: {
                value: _vm.executionDocuments,
                callback: function ($$v) {
                  _vm.executionDocuments = $$v
                },
                expression: "executionDocuments",
              },
            }),
          ]
        : [
            _c("text-row", {
              attrs: { label: "Статус закупки", compact: "" },
              model: {
                value: _vm.purchase.status.title,
                callback: function ($$v) {
                  _vm.$set(_vm.purchase.status, "title", $$v)
                },
                expression: "purchase.status.title",
              },
            }),
            _vm.purchase.is_supplier
              ? _c("text-row-documents", {
                  attrs: { label: "Документы об исполнении", compact: "" },
                  model: {
                    value: _vm.executionDocuments,
                    callback: function ($$v) {
                      _vm.executionDocuments = $$v
                    },
                    expression: "executionDocuments",
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }